/* eslint-disable max-len */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'interfaces';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state['feature/common/media-modal'] || initialState;

export const selectLoader = createSelector([selectDomain], (MediaModalState) => MediaModalState.loading);
export const selectMediaResult = createSelector([selectDomain], (MediaModalState) => MediaModalState.mediaResult);
